import { CopyIcon } from '@chakra-ui/icons'
import {
  FormControl,
  Heading,
  Input,
  Stack,
  useColorModeValue,
  VStack,
  HStack,
  FormLabel,
  Code,
  TableContainer,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Wrap,
  WrapItem,
  Box,
  IconButton,
  Center,
  Tabs,
  TabPanels,
  TabList,
  Tab,
  TabPanel,
  Text,
  Textarea,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useToast } from '@chakra-ui/react'
// import keythereum from 'keythereum'

type nodeCommands = {
  initialize_Node: string
  start_Node: string
  get_Balance?: string
  send_Transaction?: string
}

export default function GethCommands() {
  const [inputs, setInputs] = useState({
    addressOne: '0x3db6e0872c90a34a681b40decd3aa6a0d55a1f7f',
    addressTwo: '0xc216Be4b5bC605D9d30F2312BF057192f4C83AD8',
    chainId: '14333',
    bnode:
      'enode://c1f11d32ccc9f68ac48a2b3a6a2cd4b5828454b3f5fa8cce66a50e7d24e2e8ab1a3c72ca065a06e6951729f53e433954e714f2cd3be4ac48dfd5029071293df9@127.0.0.1:0',
    portOne: '30303',
    httpOne: '8545',
    authOne: '9551',
    portTwo: '30304',
    httpTwo: '8546',
    authTwo: '9552',
  })
  const [commands, setCommands] = useState<Array<nodeCommands>>([])
  const toast = useToast()

  const genesisConfig = `{
  "config": {
    "chainId": ${inputs.chainId},
    "homesteadBlock": 0,
    "eip150Block": 0,
    "eip155Block": 0,
    "eip158Block": 0,
    "byzantiumBlock": 0,
    "constantinopleBlock": 0,
    "petersburgBlock": 0,
    "istanbulBlock": 0,
    "berlinBlock": 0,
    "clique": {
      "period": 30,
      "epoch": 30000
    }
  },
  "difficulty": "1",
  "gasLimit": "8000000",
  "extradata": "0x0000000000000000000000000000000000000000000000000000000000000000${inputs.addressOne.substring(
    2
  )}0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
  "alloc": {
    "${inputs.addressOne.substring(2)}": { "balance": "300000000000000000000" },
    "${inputs.addressTwo.substring(2)}": { "balance": "400000000000000000000" },
  }
}`

  const bootNodeCommands: nodeCommands = {
    initialize_Node: `bootnode -genkey boot.key`,
    start_Node: `bootnode -nodekey ./boot.key -verbosity 7 -addr 127.0.0.1:30301`,
  }
  useEffect(() => {
    let one: nodeCommands = {
      initialize_Node: `geth --datadir ./data init ../[NAME_OF_GENESIS_CONFIG].json`,
      start_Node: `geth --networkid ${inputs.chainId} --bootnodes ${inputs.bnode} --datadir ./data --port ${inputs.portOne} --ipcdisable --syncmode 'full' --http --allow-insecure-unlock --http.corsdomain “*” --http.port ${inputs.httpOne} --authrpc.port ${inputs.authOne} --unlock '${inputs.addressOne}' --password password.txt --mine --miner.etherbase '${inputs.addressOne}' console`,
      get_Balance: `eth.getBalance('${inputs.addressOne}')`,
      send_Transaction: `eth.sendTransaction({from:'${inputs.addressOne}', to: '${inputs.addressTwo}', value: '100000000000000000'})`,
    }
    let two: nodeCommands = {
      initialize_Node: `geth --datadir ./data init ../[NAME_OF_GENESIS_CONFIG].json`,
      start_Node: `geth --networkid ${inputs.chainId} --bootnodes ${inputs.bnode} --datadir ./data --port ${inputs.portTwo} --ipcdisable --syncmode 'full' --http --allow-insecure-unlock --http.corsdomain “*” --http.port ${inputs.httpTwo} --authrpc.port ${inputs.authTwo} --unlock '${inputs.addressTwo}' --password password.txt console`,
      get_Balance: `eth.getBalance('${inputs.addressTwo}')`,
      send_Transaction: `eth.sendTransaction({from:'${inputs.addressTwo}', to: '${inputs.addressOne}', value: '100000000000000000'})`,
    }
    setCommands([one, two])
  }, [inputs])

  async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text)
    } else {
      return document.execCommand('copy', true, text)
    }
  }

  const handleCopyClick = (copyText: any) => {
    copyTextToClipboard(copyText)
      .then(() => {
        toast({
          title: 'Copied to Clipboard!',
          status: 'info',
          duration: 1500,
          isClosable: true,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const domainCommands: any = [
    {
      eth: [
        'eth.accounts',
        'eth.blockNumber',
        'eth.getTransactionFromBlock()',
        'eth.pendingTransactions',
        'eth.mining',
      ],
    },
    { admin: ['admin.nodeInfo', 'admin.peers'] },
    { net: ['net.peerCount'] },
  ]

  return (
    <VStack
      spacing={{ base: '30px' }}
      minH={{ base: '80vh', md: '80vh' }}
      wrap={'wrap'}
      align={'center'}
      justify={'center'}
      width={'full'}
    >
      <Stack
        spacing={4}
        bg={useColorModeValue('white', 'gray.700')}
        rounded={'xl'}
        boxShadow={'lg'}
        maxW={{ base: 'sm', md: '4xl' }}
        p={{ base: '6', md: '12' }}
        my={{ base: '6', md: '12' }}
        mx={{ base: '2', md: '6' }}
      >
        <Heading
          lineHeight={1}
          fontSize={{ base: '2xl', md: '4xl' }}
          color={'brand.500'}
          alignSelf={'center'}
        >
          Geth Cmds
        </Heading>

        <FormControl>
          <FormLabel>Chain Id</FormLabel>
          <Input
            type="text"
            value={inputs.chainId}
            onChange={(e: any) => {
              return setInputs({ ...inputs, chainId: e.target.value })
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Node 1 Account</FormLabel>
          <Input
            type="text"
            onChange={(e: any) => setInputs({ ...inputs, addressOne: e.target.value })}
            value={inputs.addressOne}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Node 2 Account</FormLabel>
          <Input
            type="text"
            value={inputs.addressTwo}
            onChange={(e: any) => setInputs({ ...inputs, addressTwo: e.target.value })}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Bootnode Enode</FormLabel>
          <Textarea
            value={inputs.bnode}
            onChange={(e: any) => setInputs({ ...inputs, bnode: e.target.value })}
          />
        </FormControl>

        <HStack>
          <VStack>
            <FormControl>
              <FormLabel>Node 1 Port</FormLabel>
              <Input
                type="text"
                value={inputs.portOne}
                onChange={(e: any) => setInputs({ ...inputs, portOne: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Node 1 Http Port</FormLabel>
              <Input
                type="text"
                value={inputs.httpOne}
                onChange={(e: any) => setInputs({ ...inputs, httpOne: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Node 1 Auth RPC Port</FormLabel>
              <Input
                type="text"
                value={inputs.authOne}
                onChange={(e: any) => setInputs({ ...inputs, authOne: e.target.value })}
              />
            </FormControl>
          </VStack>
          <VStack>
            <FormControl>
              <FormLabel>Node 2 Port</FormLabel>
              <Input
                type="text"
                value={inputs.portTwo}
                onChange={(e: any) => setInputs({ ...inputs, portTwo: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Node 2 Http Port</FormLabel>
              <Input
                type="text"
                value={inputs.httpTwo}
                onChange={(e: any) => setInputs({ ...inputs, httpTwo: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Node 2 Auth RPC Port</FormLabel>
              <Input
                type="text"
                value={inputs.authTwo}
                onChange={(e: any) => setInputs({ ...inputs, authTwo: e.target.value })}
              />
            </FormControl>
          </VStack>
        </HStack>
      </Stack>
      <Tabs
        width={{ base: 'sm', md: '4xl' }}
        variant="soft-rounded"
        colorScheme="teal"
        align="center"
      >
        <TabList>
          <Tab>Clique Genesis</Tab>
          <Tab>Boot Node</Tab>
          <Tab>Node 1 and 2</Tab>
          <Tab>Domain</Tab>
        </TabList>
        <TabPanels maxWidth={{ base: 'sm', md: '4xl' }}>
          <TabPanel alignItems={'flex-start'} display={'flex'}>
            <Stack
              direction="column"
              bgColor={'white'}
              p={'12px'}
              maxWidth={'4xl'}
              boxShadow={'lg'}
              rounded={'xl'}
              fontSize={'xs'}
              justify={'flex-start'}
            >
              <HStack alignItems={'center'} justifyContent={'space-between'}>
                <Heading fontSize={'lg'}>Clique Config</Heading>
                <IconButton
                  aria-label={'Copy to Clipboard'}
                  onClick={() => handleCopyClick(genesisConfig)}
                  float={'right'}
                  icon={<CopyIcon />}
                />
              </HStack>
              <HStack bgColor={'gray.200'} px={4} py={2} rounded={'md'} alignItems={'top'}>
                <Code overflowX={'scroll'} display={'flex'} textAlign={'left'}>
                  <pre>{genesisConfig}</pre>
                </Code>
              </HStack>
            </Stack>
          </TabPanel>
          <TabPanel>
            <Stack
              direction="column"
              bgColor={'white'}
              p={'12px'}
              maxWidth={{ base: 'sm', md: '4xl' }}
              boxShadow={'lg'}
              rounded={'xl'}
            >
              <Heading fontSize={'lg'}>{`Bootnode Node Commands`}</Heading>
              {Object.keys(bootNodeCommands).map((cm: any) => {
                let prop = cm as keyof nodeCommands
                return (
                  <HStack
                    bgColor={'gray.200'}
                    px={4}
                    py={2}
                    justifyContent={'space-between'}
                    key={bootNodeCommands[prop]}
                    rounded={'md'}
                    alignItems={'top'}
                  >
                    <Box textAlign={'left'}>
                      <Text fontSize={'md'} fontWeight={'600'}>
                        {prop}
                      </Text>
                      <Code display={'flex'} textAlign={'left'}>
                        {bootNodeCommands[prop]}
                      </Code>
                    </Box>
                    <IconButton
                      aria-label={'Copy to Clipboard'}
                      onClick={() => handleCopyClick(bootNodeCommands[prop])}
                      float={'right'}
                      icon={<CopyIcon />}
                      p={'0'}
                    />
                  </HStack>
                )
              })}
            </Stack>
          </TabPanel>
          <TabPanel>
            <Stack>
              {commands.map((cmd: nodeCommands, index: number) => {
                return (
                  <Stack
                    direction="column"
                    key={cmd.get_Balance}
                    bgColor={'white'}
                    p={'12px'}
                    maxWidth={'4xl'}
                    boxShadow={'lg'}
                    rounded={'xl'}
                  >
                    <Heading fontSize={'lg'}>{`Node ${index + 1} Commands`}</Heading>
                    {Object.keys(cmd).map((cm: any) => {
                      let prop = cm as keyof nodeCommands
                      return (
                        <HStack
                          bgColor={'gray.200'}
                          px={4}
                          py={2}
                          justifyContent={'space-between'}
                          key={cmd[prop]}
                          rounded={'md'}
                          alignItems={'top'}
                          overflowX={'scroll'}
                        >
                          <Box textAlign={'left'}>
                            <Text fontSize={'md'} fontWeight={'600'}>
                              {prop}
                            </Text>
                            <Code display={'flex'} textAlign={'left'}>
                              {cmd[prop]}
                            </Code>
                          </Box>
                          <IconButton
                            aria-label={'Copy to Clipboard'}
                            onClick={() => handleCopyClick(cmd[prop])}
                            float={'right'}
                            icon={<CopyIcon />}
                            p={'0'}
                          />
                        </HStack>
                      )
                    })}
                  </Stack>
                )
              })}
            </Stack>
          </TabPanel>
          <TabPanel>
            <HStack
              maxWidth={{ base: 'sm', md: '4xl' }}
              justify={'center'}
              alignItems={'flex-start'}
              gap={{ base: '30px', md: '10px' }}
            >
              {domainCommands.map((dm: any) => {
                let domain = Object.keys(dm)[0]
                return (
                  <TableContainer key={domain} boxShadow={'lg'}>
                    <Table size="md" variant="striped">
                      <Thead>
                        <Tr>
                          <Th>{domain} Commands</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {dm[`${domain}`].map((cmd: string) => {
                          return (
                            <Tr key={cmd}>
                              <Td>{cmd}</Td>
                            </Tr>
                          )
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                )
              })}
            </HStack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  )
}
